import { createColumnHelper } from '@tanstack/react-table';
import { Table, TableProvider, useTableState } from '@optimus-web/core';
import { LocalizedEnum, LocalizedText } from '@mews/framework';
import { TextKey } from '@mews-commander/enums';
import { TaxEnvironmentsFiltersSchema } from '../types';
import { FilterValueKey } from '../constants';
import { useTaxEnvironmentData } from '../../../core/globalization';
import { TaxationsSubTable } from './taxationsSubTable';

const helper = createColumnHelper<TaxEnvironmentsFiltersSchema>();

const mapping = [
    helper.accessor(FilterValueKey.code, {
        header: () => <LocalizedText textKey={TextKey.Code} />,
    }),
    helper.accessor(FilterValueKey.englishName, {
        header: () => <LocalizedText textKey={TextKey.Name} />,
    }),
    helper.accessor(FilterValueKey.country, {
        header: () => <LocalizedText textKey={TextKey.Country} />,
    }),
    helper.accessor(FilterValueKey.depositTaxRate, {
        header: () => <LocalizedText textKey={TextKey.DepositTaxRatePlural} />,
        cell: (props) => {
            const depositTaxRate = props.getValue();
            return <LocalizedEnum prefix="DepositTaxRateMode" value={depositTaxRate} />;
        },
    }),
    helper.accessor(FilterValueKey.taxations, {
        header: () => <LocalizedText textKey={TextKey.Taxations} />,
        cell: (props) => {
            const taxations = props.getValue();
            if (Array.isArray(taxations)) {
                return <TaxationsSubTable taxations={taxations} />;
            }
            return null;
        },
    }),
];

export const TaxEnvironmentsTable = () => {
    const [tableState, setTableState] = useTableState<TaxEnvironmentsFiltersSchema>();

    const { taxEnvironmentData, isLoading } = useTaxEnvironmentData();
    return (
        <TableProvider state={tableState} onStateChange={setTableState} as="section" columns={mapping}>
            {taxEnvironmentData && (
                <Table
                    fixedHeader
                    loading={isLoading}
                    data={taxEnvironmentData}
                    uniqueRowId="code"
                    amountOfRows={taxEnvironmentData.length}
                />
            )}
        </TableProvider>
    );
};
